import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../../api/api_users';

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const performLogout = async () => {
            try {
                await logoutUser(navigate);
            } catch (error) {
                console.error('Error logging out:', error);
            }
        };

        performLogout();
    }, [navigate]);

    return null;
};

export default Logout;
